import { FunctionComponent } from 'react'
import styled, { useTheme, css } from 'styled-components'
import SvgIcon from '../SvgIcon'
import { SvgIconName } from '@components/SvgIcon/types'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'

interface Props {
  type?: SvgIconName
}

const StyledPlayIcon = styled(SvgIcon)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10%;
  background-color: ${({ theme }) => theme.colors.brandColors.brand_55};

  ${desktopCSS(css`
    width: 60px;
    height: 60px;
  `)}

  ${tabletCSS(css`
    width: 48px;
    height: 48px;
  `)}

  ${mobileCSS(css`
    width: 40px;
    height: 40px;
  `)}
`

const PlayIcon: FunctionComponent<Props> = ({ type = 'video-play' }) => {
  const theme = useTheme()

  return (
    <StyledPlayIcon
      className="play-icon"
      iconName={type}
      size={60}
      color={theme.colors.white}
    />
  )
}

export default PlayIcon
